import { supabase } from './supabaseClient';
import { Investidor, AporteResgate } from './types';

// Investidores
export const getInvestidores = async () => {
    const { data, error } = await supabase.from('investidores').select('*').order('nome');
    if (error) throw error;
    return data;
};

export const addInvestidor = async (investidor: Omit<Investidor, 'id'>) => {
    const { data, error } = await supabase.from('investidores').insert([investidor]).select();
    if (error) throw error;
    return data;
};

export const updateInvestidor = async (id: number, investidor: Partial<Investidor>) => {
    const { data, error } = await supabase.from('investidores').update(investidor).eq('id', id).select();
    if (error) throw error;
    return data;
};

export const deleteInvestidor = async (id: number) => {
    const { error } = await supabase.from('investidores').delete().eq('id', id);
    if (error) throw error;
};

// Aportes e Resgates
export const getAportesResgates = async (filters: { obra_id?: number, investidor_id?: number, data_inicio?: string, data_fim?: string } = {}) => {
    let query = supabase.from('aportes_resgates').select(`
        *,
        obras (nome),
        investidores (nome),
        anexos:aportes_resgates_anexos (*)
    `).order('data', { ascending: false });

    if (filters.obra_id) query = query.eq('obra_id', filters.obra_id);
    if (filters.investidor_id) query = query.eq('investidor_id', filters.investidor_id);
    if (filters.data_inicio) query = query.gte('data', filters.data_inicio);
    if (filters.data_fim) query = query.lte('data', filters.data_fim);

    const { data, error } = await query;
    if (error) throw error;
    return data.map((item: any) => ({
        ...item,
        obra_nome: item.obras?.nome,
        investidor_nome: item.investidores?.nome
    }));
};

export const addAporteResgate = async (aporteResgate: Omit<AporteResgate, 'id' | 'obra_nome' | 'investidor_nome' | 'anexos'>, anexosData: any[]) => {
    const { data, error } = await supabase.rpc('add_aporte_resgate', {
        p_aporte_data: aporteResgate,
        p_anexos_data: anexosData
    });
    if (error) throw error;
    return data;
};

export const updateAporteResgate = async (id: number, aporteResgate: Partial<AporteResgate>, newAnexosData: any[], anexosIdsToDelete: number[]) => {
    // Remove extra fields that might be present but not in the table
    const { anexos, obra_nome, investidor_nome, ...cleanAporteResgate } = aporteResgate as any;

    const { data, error } = await supabase.rpc('update_aporte_resgate', {
        p_id: id,
        p_aporte_data: cleanAporteResgate,
        p_new_anexos_data: newAnexosData,
        p_anexos_ids_to_delete: anexosIdsToDelete
    });
    if (error) throw error;
    return data;
};

export const getAporteResgateAnexoUrl = (path: string) => {
    const { data } = supabase.storage.from('anexos').getPublicUrl(path);
    return data.publicUrl;
};

export const deleteAporteResgate = async (id: number) => {
    const { error } = await supabase.from('aportes_resgates').delete().eq('id', id);
    if (error) throw error;
};
